export const LABELS = {
    PAGE_TITLE: "Attended Trainings",
    ADD_BUTTON: "Add Training",
    MODAL_TITLE: "Add New Training",
    TRAINING_NAME_LABEL: "Training Name",
};